/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Dimensions, ScrollView, FlatList } from 'react-native'
import styles from './Styles/ExploraKargoeTagsStyle'

import Spacer from './Spacer'
import KargoeTagRow from './KargoeTagRow';
import ImageComponent from './ImageComponent';
import ViewAllPostsComponent from './ViewAllPostsComponent';
import { isBlank, checkPrice } from '../Lib/utils'
import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview";
import I18n from "i18n-js"

let { width } = Dimensions.get('window')
const minHeight = 75
const viewabilityConfig = { viewAreaCoveragePercentThreshold : -200 }
export default class ExploraKargoeTags extends Component {
  constructor(props) {
    super(props)
  }
  componentDidUpdate(previousProps, previousState) {
    if (this.props.data !== previousProps.data && this.scrollView)
      this.scrollView.scrollToOffset({ offset : 0, animated : false })
  }
  dispatchUpdate = item => {
    item.viewable = true
    if(item.getting || item.got) return
    item.getting = true
    this.props.getItemPosts(item)
    .then(resp => {
        if(item) {
          item.got = true
          item.Posts = resp.data.data
          if( this.rerender )
            clearTimeout(this.rerender)
          this.rerender = setTimeout(( ) => this.setState({ render : true }), 333)
        }
    })
  }
  onViewableItemsChanged = ({ changed, viewableItems }) => {
    var viewable = 0, hit = 0
    if(! viewableItems.length) return false
    for(var i = 0, data = this.props.data[i]; i < this.props.data.length; data = this.props.data[++i]) {
      if(i == viewableItems[0].index) {
        this.dispatchUpdate(data)
        hit = 1
        ++viewable
      }
      else if(hit && viewableItems.length > hit) ++hit && ++viewable && this.dispatchUpdate(data)
      else if(data.viewable) ++ viewable
    }
    if(hit > 0 || viewable === this.props.data.length) this.props.resetIdleTimeout(hit)

    // when 100% of items are viewable, signal idle state immediately
    // set a timeout of DownloadImageAverageTime, then signal idle state
    // when idle state is procced, we'll 'finally' download other tabs in the background
    this.setState({ render : true })
    // for(var i = 0; i < changed.length; ++ i) if(! changed[i].isViewable && this.props.data[changed[i].index]) this.props.data[changed[i].index].viewable = false
  }
  render( ) {
    return (

          <FlatList ref={ref=>this.scrollView=ref} contentContainerStyle={{ paddingBottom : 333, backgroundColor : 'white' }} data={this.props.data}
              onViewableItemsChanged={this.onViewableItemsChanged}
              viewabilityConfig={viewabilityConfig} ListEmptyComponent={this.props.empty}
              onRefresh={this.props.onRefresh} refreshing={this.props.refreshing}
              renderItem={({ item, index }) =>
                  item.viewable
                      ? <View style={{ overflow : 'hidden' }}>
                            <KargoeTagRow onLeftPress={this.props.onLeftPress} onPressRightIcon={() => this.props.onPressRightIcon(item, index)}
                              key={index} title={item.Brand} mainTitle={item.Title} data={item}
                              subTitle={I18n.t("explora.price") + ' : '+ checkPrice(item.PriceMin, item.PriceMax)}/>
                            <View style={{ flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
                              {item.Posts.map((Post, index) => index < 3 && <ImageComponent useThumb={true} onPress={( ) => this.props.onPressPost(item, index)} key={index} index={index} data={Post}/>)}
                              {item.Posts.length > 0 && <ViewAllPostsComponent onPress={() => this.props.viewAllPosts(item)}/>}
                            </View>
                            <Spacer style={styles.spacer} />
                        </View>
                      : <View style={{ width : width, height : item.height || minHeight }}/>
              }/>

      )
  }
}
